<template>
  <v-container>
    <v-row>
      <v-col
        v-for="(card, index) in cards"
        :key="index"
        cols="12"
        sm="6"
        md="6"
      >
        <v-card
          :class="['content-card', 'h-100', { unavailable: !card.available, 'interactive-card': card.available }]"
          elevation="0"
          @click="card.available && $router.push(card.path)"
        >
          <v-card-text class="text-center py-4">
            <v-card-title class="text-h6 mb-2">
              {{ card.title }}
            </v-card-title>
            <v-card-subtitle class="text-subtitle-1 text-grey">
              {{ card.description }}
            </v-card-subtitle>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "QuickLinks",
  setup() {
    const cards = [
      {
        title: "List",
        description: "List new items",
        path: { path: "/list", query: { openNav: "1" } },
        available: true,
      },
      {
        title: "Listing Sessions",
        description: "View listing sessions",
        path: { path: "/listing-sessions", query: { openNav: "1" } },
        available: true,
      },
      {
        title: "Inventory",
        description: "Manage your inventory",
        path: { path: "/inventory", query: { openNav: "1" } },
        available: true,
      },
      {
        title: "Sales Dashboard",
        description: "View sales trends and totals",
        path: { path: "/sales/dashboard", query: { openNav: "1" } },
        available: true,
      },
      {
        title: "Images",
        description: "Upload item images",
        path: { path: "/images", query: { openNav: "1" } },
        available: true,
      },
      {
        title: "Settings",
        description: "Manage your settings",
        path: { path: "/settings", query: { openNav: "1" } },
        available: true,
      },
      
    ];

    return {
      cards
    };
  }
});
</script>

<style scoped lang="scss">
.v-card {
  min-width: 220px;
  background-color: white !important;

  &.unavailable {
    opacity: 0.7;
    cursor: not-allowed;
    background-color: #f5f5f5 !important;
  }

  .v-card-title {
    font-weight: 500;
    line-height: 1.2;
  }

  .v-card-subtitle {
    opacity: 0.7;
  }
}

.v-col {
  padding: 12px;
}
</style>
